/**
 * Endpoints that don't need to raise error toast
 */
export const errorBlackList: string[] = []
